/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Information about the software version that is deployed
 */
export type BuildConfig = {
  /**
   * Branch name
   */
  branch: string;
  /**
   * Commit hash
   */
  commit: string;
  /**
   * UI branch being previewed (if any)
   */
  previewBranch?: string | undefined;
};

/** @internal */
export const BuildConfig$inboundSchema: z.ZodType<
  BuildConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  branch: types.string(),
  commit: types.string(),
  preview_branch: types.optional(types.string()),
}).transform((v) => {
  return remap$(v, {
    "preview_branch": "previewBranch",
  });
});

export function buildConfigFromJSON(
  jsonString: string,
): SafeParseResult<BuildConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BuildConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BuildConfig' from JSON`,
  );
}
